export const SALES_MARKETING_VIEW_BANNER_MS = 4000;

export const salesMarketingViewBannerText = (marketingViewName) => {
  const name = typeof marketingViewName === 'string' ? marketingViewName.trim() : '';
  if (!name) {
    return '';
  }
  return `Using marketing view ${name}`;
};

export const shouldShowSalesMarketingViewBanner = ({
  marketingViewName,
  isPageReady,
}) => {
  return Boolean(isPageReady && salesMarketingViewBannerText(marketingViewName));
};
